import React, { useEffect, useState } from 'react';

import {
  ButtonsContainer,
  Oval,
  StepContainer,
  StepCounter,
  StepFooter,
} from './Walkthrough.styles.js';
import Modal from '../Modal/Modal';
import WithTarget from './WithTarget.inner.js';
import Buttons from './Buttons.inner.js';

const Walkthrough = ({
  steps,
  show,
  onFinish,
  showOverlay = true,
  border = false,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    if (currentStep !== 0) {
      setCurrentStep(0);
    }
  }, [show]);

  const { render, position, target } = steps[currentStep];

  const isLastStep = currentStep === steps.length - 1;

  const endStep = () => onFinish();
  const nextStep = () =>
    !isLastStep ? setCurrentStep((actual) => actual + 1) : endStep();

  const currentTypeStep =
    currentStep === 0 ? 'firststep' : isLastStep ? 'laststep' : 'middlestep';

  const getStepRender = () => (
    <StepContainer border={!!border}>
      {render}
      <StepFooter>
        {steps.length > 1 && (
          <StepCounter>
            {steps.map((step, index) => (
              <Oval
                key={`steps-oval-${index}`}
                variant={currentStep === index ? 'primary' : 'neutral-3'}
              />
            ))}
          </StepCounter>
        )}
        <ButtonsContainer>
          <Buttons
            step={currentTypeStep}
            stepData={steps[currentStep]}
            endStep={endStep}
            nextStep={nextStep}
          />
        </ButtonsContainer>
      </StepFooter>
    </StepContainer>
  );

  if (!show) return false;

  const targetElement = document.querySelector(target);

  if (!targetElement) {
    return (
      <WithoutTarget showOverlay={showOverlay}>{getStepRender()}</WithoutTarget>
    );
  }

  return (
    <WithTarget
      target={targetElement}
      position={position}
      showOverlay={showOverlay}
      border={!!border}
    >
      {getStepRender()}
      {targetElement.scrollIntoView(true)}
    </WithTarget>
  );
};

const WithoutTarget = ({ children, showOverlay }) => {
  return (
    <Modal isOpen={true} size='md' showOverlay={showOverlay}>
      {children}
    </Modal>
  );
};

export default Walkthrough;
